import type { DotStudioMode } from './types';
export const PATTERN_GROUP_ORDER = [
  'signal',
  'horizontal',
  'history',
  'texture',
  'flow',
  'interference',
  'cells',
  'mark',
  'triangle',
] as const;

export type PatternGroupId = (typeof PATTERN_GROUP_ORDER)[number];

export const PATTERN_GROUPS: Record<PatternGroupId, Record<string, string>> = {
  signal: { breakthrough: 'Breakthrough' },
  horizontal: { horizon: 'Horizon', ridge: 'Ridge' },
  history: { marketLife: 'Market Life', halfLife: 'Half-Life' },
  texture: { crowd: 'Crowd Noise' },
  flow: {
    current: 'Current',
    eddy: 'Eddy',
    confluence: 'Confluence',
    cascade: 'Cascade',
    braid: 'Braid',
  },
  interference: {
    ripple: 'Ripple',
    resonance: 'Resonance',
    beat: 'Beat',
    standing: 'Standing',
    moire: 'Moiré',
  },
  cells: {
    edges: 'Edges',
    territory: 'Territory',
    crystal: 'Crystal',
    stipple: 'Stipple',
  },
  mark: {
    converge: 'Converge',
    radiate: 'Radiate',
    pinwheel: 'Pinwheel',
  },
  triangle: { arrows: 'Arrows' },
};

export const PATTERN_GROUP_LABELS: Record<PatternGroupId, string> = {
  signal: 'Signal',
  horizontal: 'Horizontal',
  history: 'History',
  texture: 'Texture',
  flow: 'Flow · vector field',
  interference: 'Interference · waves',
  cells: 'Cells · partition',
  mark: 'Mark · sectors',
  triangle: 'Triangle · primitive',
};

/** Modes exposed in the v9.1 pattern picker (excludes legacy source-only presets). */
export const PATTERN_PICKER_MODES = Object.values(PATTERN_GROUPS).flatMap((group) =>
  Object.keys(group),
) as DotStudioMode[];

export function dotStudioModeLabel(mode: DotStudioMode): string {
  for (const group of Object.values(PATTERN_GROUPS)) {
    const label = group[mode];
    if (label !== undefined) {
      return label;
    }
  }
  return mode;
}
